import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { Form, Formik } from 'formik';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import Button from '@mui/material/Button';
import { onForgotPassword } from '../../../store/actions/Auth';
import { useRegisterStyles } from '..';
import InputField from '../../../common/InputField';
import { useCommonStyles } from '../../../common/common';
import forgotPasswordSchema from '../../../schemas/forgotPassword.schema';
import AppLogoComp from '../../../common/AppLogo';

interface LoginWithUserState {
	email: string;
}

const ForgotPassword = () => {
	const dispatch = useDispatch();
	const [values] = useState<LoginWithUserState>({
		email: ''
	})

	const classes = useRegisterStyles();
	const {
		pointer, signInButton, paper, formRoot
	} = classes
	const commonClasses = useCommonStyles()
	const { d_f_row_center, mainContainer, w_100 } = commonClasses
	const submitHandler = (data: LoginWithUserState, setSubmitting: any) => {
		setSubmitting(true);
		dispatch(onForgotPassword(data.email));
		setSubmitting(false);
	}

	return (
		<Box className={mainContainer}>
			<Box className={d_f_row_center} height="inherit">
				<Grid container>
					<Grid item xs={12} sm={3} lg={4}></Grid>
					<Grid item xs={12} sm={6} lg={4} style={{ backgroundColor: '#d7d5d526', borderRadius: '4px', }}>
						<AppLogoComp />
						<Paper className={paper}>
							<Formik
								validateOnChange={true}
								initialValues={{
									...values
								}}
								validationSchema={forgotPasswordSchema}
								onSubmit={(data, { setSubmitting }) => submitHandler(data, setSubmitting)}>
								{({ isSubmitting }) => (
									<Form className={formRoot} noValidate autoComplete='off'>
										<Box
											mb={{ xs: 2, xl: 4 }}
											component='div'
											fontSize={16}>
											Enter email address
										</Box>
										<Box mb={{ xs: 3, xl: 4 }}>
											<InputField
												placeholder='Enter email address'
												name='email'
												variant='outlined'
												className={clsx(w_100)}
											/>
										</Box>
										<Box
											display='flex'
											flexDirection='column'
											mb={{ xs: 3, xl: 3 }}>
											<Button
												type='submit'
												color="primary"
												variant="contained"
												disabled={isSubmitting}
												className={clsx(signInButton)}>
												Forgot Password
											</Button>
										</Box>
										<Box
											mb={{ xs: 3, xl: 4 }}
											display='flex'
											flexDirection={{ xs: 'column', sm: 'row' }}
											alignItems={{ sm: 'center' }}
											justifyContent={{ sm: 'center' }}
											fontSize={15}>
											<Box
												color='primary.secondary'
												component='span'
												className={pointer}
												fontSize={15}
											>
												Already a member? <Link to="/signin">Sign In</Link> here
											</Box>
										</Box>
										<Box
											mb={{ xs: 3, xl: 4 }}
											display='flex'
											flexDirection={{ xs: 'column', sm: 'row' }}
											alignItems={{ sm: 'center' }}
											justifyContent={{ sm: 'center' }}
											fontSize={15}>
											<Box
												color='primary.secondary'
												component='span'
												className={pointer}
												fontSize={15}
											>
												<Link to="/products">Home</Link>
											</Box>
										</Box>
									</Form>
								)}
							</Formik>
						</Paper>
					</Grid>
					<Grid item xs={12} sm={3} lg={4}></Grid>
				</Grid>
			</Box>
		</Box>
	);
};

export default ForgotPassword;
